import { requestBuilder } from '../../http/RequestBuilder';
import type { IBill, PartialBill } from '../types/Bill';

type BillsApiUpdateBillParams = Pick<IBill, 'membershipId' | 'id'>;

const useApproveBill = requestBuilder.mutation<
    PartialBill,
    null,
    BillsApiUpdateBillParams
>({
    endpoint: ({ membershipId, id }) =>
        `/api/holistic-bills/${membershipId}/bill/${id}/approve`,
    method: 'PATCH',
});

export default useApproveBill;
